import { cn } from '../../lib/cn';
import { Card, Badge, Button, ConfidenceIndicator } from '../ui';
import type { DecisionDesign } from '../../hx/framework';

type Props = {
  decision: DecisionDesign;
  onAccept?: () => void;
  onAlternative?: (option: string) => void;
  className?: string;
};

export function DecisionCard({ decision, onAccept, onAlternative, className }: Props) {
  return (
    <Card className={cn('border-l-4 border-l-brand-500', className)}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <Badge variant="success">Recommended</Badge>
        <ConfidenceIndicator score={decision.confidence} size="sm" />
      </div>
      <p className="mt-3 font-medium text-slate-900 dark:text-slate-100">{decision.recommended_option}</p>
      {decision.expected_impact && (
        <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Impact: {decision.expected_impact}</p>
      )}
      {decision.evidence && decision.evidence.length > 0 && (
        <ul className="mt-3 text-xs text-slate-500">
          {decision.evidence.map((e) => <li key={e}>• {e}</li>)}
        </ul>
      )}
      {decision.risk && (
        <p className="mt-2 text-xs text-warning-700 dark:text-warning-400">Risk: {decision.risk}</p>
      )}
      {decision.rollback_plan && (
        <p className="mt-1 text-xs text-slate-400">Rollback: {decision.rollback_plan}</p>
      )}
      <div className="mt-4 flex flex-wrap gap-2">
        <Button size="sm" onClick={onAccept}>Accept Recommendation</Button>
        {decision.alternatives?.map((alt) => (
          <Button key={alt} variant="secondary" size="sm" onClick={() => onAlternative?.(alt)}>
            {alt}
          </Button>
        ))}
      </div>
    </Card>
  );
}
